<template>
  <div>
    <input
      :id="inputId"
      :data-testid="inputId && `${inputId}-checkbox`"
      type="checkbox"
      name="toggle"
      :checked="darkIsActive"
      class="hidden"
    >
    <div
      :data-testid="inputId"
      class="theme-switcher"
      :class="{
        'theme-switcher--dark': darkIsActive && !gray,
        'theme-switcher--gray-light': !darkIsActive && gray,
        'theme-switcher--transparent': transparent,
        'theme-switcher--gray': gray
      }"
      @click="toggle"
    >
      <div class="theme-switcher__bullet" />
      <div class="theme-switcher__icon">
        <IconMoon v-if="darkIsActive" />
        <IconSun v-else />
      </div>
    </div>
  </div>
</template>

<script>
import IconSun from '@/components/icons/IconSun.vue'
import IconMoon from '@/components/icons/IconMoon.vue'

export default {
  name: 'ThemeSwitcher',
  components: { IconSun, IconMoon },
  props: {
    theme: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      default: undefined
    },
    transparent: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    }
  },
  emits: ['switchTheme'],
  computed: {
    darkIsActive() {
      return this.theme === 'dark'
    }
  },
  methods: {
    toggle() {
      const theme = this.darkIsActive ? 'light' : 'dark'
      this.$emit('switchTheme', theme)
    }
  }
}
</script>

<style scoped lang="scss">
.theme-switcher {
  --theme-switcher-background: #a2a9ea;
  --theme-switcher-icon-color: var(--color-white);
  width: 55px;
  height: 28px;
  background: var(--theme-switcher-background);
  border-radius: var(--border-radius-32);
  border: 0;
  cursor: pointer;
  position: relative;
  margin: 0;

  .theme-switcher__bullet {
    display: block;
    width: 16px;
    height: 16px;
    border-radius: var(--border-radius-16);
    background: #ffffff; // should be always white
    position: absolute;
    left: calc(100% - 22px);
    right: auto;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    transition: 0.3s ease-in-out;
  }

  .theme-switcher__icon {
    color: var(--theme-switcher-icon-color);
    position: absolute;
    left: 6px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }

  &.theme-switcher--dark {
    border: 1px solid #88a1b9;
    background-color: transparent;

    .theme-switcher__bullet {
      left: 6px;
    }

    .theme-switcher__icon {
      color: #facc15;
      left: unset;
      right: 6px;
    }
  }

  &.theme-switcher--transparent {
    background-color: transparent;
    border: 1px solid rgb(255 255 255 / 40%);
  }

  &.theme-switcher--gray {
    --theme-switcher-background: var(--color-zinc-300);
    --theme-switcher-icon-color: var(--color-zinc-700);
    width: 48px;
    height: 22px;

    .theme-switcher__bullet {
      width: 18px;
      height: 18px;
      left: 2px;
      transform: translateX(26px);
    }

    .theme-switcher__icon {
      left: 2px;
    }
  }

  &.theme-switcher--gray-light {
    .theme-switcher__bullet {
      transform: translateX(0);
    }

    .theme-switcher__icon {
      left: unset;
      right: 2px;
    }
  }
}

.hidden {
  display: none;
}
</style>
